import { GridColDef } from '@mui/x-data-grid';
import IPipeMarking from '../../models/Indexes/iPipeMarking';
import ProductReferenceCell from '../cell/ProductReferenceCell';
import ProductAttributeDisplayCell from '../cell/ProductAttributeDisplayCell';
import SalesOrgCell from '../cell/SalesOrgCell';

const PipeMarking = (): GridColDef<IPipeMarking>[] => {
  return [
    {
      field: 'primaryImageWithUrlMed',
      headerName: 'Reference',
      flex: 2,
      renderCell: (params) => <ProductReferenceCell row={params.row} imageUrl={params.value} />,
      sortable: false,
      filterable: false,
    },
    {
      field: 'salesOrgDiv',
      headerName: 'Sales Org',
      flex: 2,
      renderCell: (params) => <SalesOrgCell params={params} />,
    },
    {
      field: 'catalogDisplay',
      headerName: 'Catalog',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="catalogActual" />
      ),
    },
    { field: 'productYNumber', headerName: 'Y#', flex: 2 },
    { field: 'type', headerName: 'Type', flex: 2 },
    { field: 'productDescription', headerName: 'Description', flex: 4 },
    {
      field: 'materialDisplay',
      headerName: 'Material',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="materialActual" />
      ),
    },
    {
      field: 'colorDisplay',
      headerName: 'Color',
      flex: 3,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="colorActual" />
      ),
    },
    {
      field: 'legendDisplay',
      headerName: 'Legend',
      flex: 3,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="legendActual" />
      ),
    },
    {
      field: 'styleDisplay',
      headerName: 'Style',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="styleActual" />
      ),
    },
    {
      field: 'pipeMarkerMountingStyleDisplay',
      headerName: 'Mounting Style',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell
          row={params.row}
          displayValue={params.value}
          actualValueKey="pipeMarkerMountingStyleActual"
        />
      ),
    },
    {
      field: 'pipeDiameterDisplay',
      headerName: 'Diameter',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="pipeDiameterActual" />
      ),
    },
    { field: 'sapStatus', headerName: 'SAP Status', flex: 2 },
  ];
};

export default PipeMarking;
